import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


import {RecaptchaModule} from 'ng-recaptcha';
import { NgRecaptcha3Service } from "ng-recaptcha3";

import * as echarts from 'echarts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxEchartsModule } from 'ngx-echarts';

export function chartModule(): any {
  return import('echarts');
}
// import {
//   BarChart, PieChart, GaugeChart
// } from 'echarts/charts';
// import {
//   TitleComponent,
//   TooltipComponent,
//   GridComponent
// } from 'echarts/components';
// Import the Canvas renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
// import {
//   CanvasRenderer
// } from 'echarts/renderers';
import 'echarts/theme/macarons.js';

// HttpClient module for RESTful API
import { HttpClientModule } from '@angular/common/http';
////import { MatButtonModule } from '@angular/material/button';
////import { MatCheckboxModule } from '@angular/material/checkbox';
////import { MatSelectModule } from '@angular/material/select';
////import { MatMenuModule } from '@angular/material/menu';
////import {MatSidenavModule  } from '@angular/material/sidenav';

import { MatStepperModule } from '@angular/material/stepper';
//import { MatTabsModule } from '@angular/material/tabs';
////import { MatRadioModule } from '@angular/material/radio';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSelectModule } from 'ngx-select-ex';
import { ContextMenuModule } from 'ngx-contextmenu';
import { TreeModule } from 'angular-tree-component';

import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { CheckBoxModule, SwitchModule } from '@syncfusion/ej2-angular-buttons';



//import { UploaderModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
////import { GridModule, PageService, SortService, FilterService, ToolbarService, EditService, GroupService, ToolbarItems, EditSettingsModel, ExcelExportService  } from '@syncfusion/ej2-angular-grids';
////import { DropDownListModule, MultiSelectModule} from '@syncfusion/ej2-angular-dropdowns';
////import { ChartAllModule, AccumulationChartAllModule, RangeNavigatorAllModule } from '@syncfusion/ej2-angular-charts'
////import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
////import { DialogModule } from '@syncfusion/ej2-angular-popups';
////import { CircularGaugeModule } from '@syncfusion/ej2-angular-circulargauge';

////import { MatTooltipModule } from '@angular/material/tooltip';
////import { MatSliderModule } from '@angular/material/slider';

import { NgxSliderModule } from '@angular-slider/ngx-slider';
/** New Site **/
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
//import { AgGridModule } from 'ag-grid-angular';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { AngularEditorModule } from '@kolkov/angular-editor';
/**  For Image Cropper Import themes and Other Module */
import { LyResizingCroppingImageModule } from '@alyle/ui/resizing-cropping-images';
import { LyIconModule } from '@alyle/ui/icon';
import { LyButtonModule } from '@alyle/ui/button';
import { LyThemeModule, LY_THEME } from '@alyle/ui';
import { MinimaLight } from '@alyle/ui/themes/minima';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { UiSwitchModule } from 'ngx-toggle-switch';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { NotificationComponent } from './component/notification/notification.component';
import { DashboardDigitalComponent } from './component/dashboard-digital/dashboard-digital.component';
import { SLADashboardComponent } from './component/sladashboard/sladashboard.component';
import { AdminboardComponent } from './component/admindashboard/admindashboard.component';

//OneID
import { PingcallbackComponent } from './component/pingcallback/pingcallback.component';
import { PingredirectComponent } from './component/pingredirect/pingredirect.component';
import { NotauthorizedComponent } from './component/notauthorized/notauthorized.component';

//Admin
import { AdminComponent } from './component/admin/admin.component';
import { InboxComponent } from './component/inbox/inbox.component';
import { LoginComponent } from './component/login/login.component';
import { LoginExternalComponent } from './component/login-external/login-external.component';
import { LoginPingIDComponent } from './component/login-pingid/login-pingid.component';

import { DepartmentComponent } from './component/admin/department/department.component';
import { DivisionComponent } from './component/admin/division/division.component';
import { InteractionComponent } from './component/admin/interaction/interaction.component';
import { TenantComponent } from './component/admin/tenant/tenant.component';
import { UserMasterComponent } from './component/admin/usermaster/usermaster.component';
import { UserProfileComponent } from './component/userprofile/userprofile.component';

import { UserGroupComponent } from './component/admin/usergroup/usergroup.component';
//SLA KPI
import { SLAComponent } from './component/slakpi/sla/sla.component';
import { KPIComponent } from './component/slakpi/kpi/kpi.component';
import { SLAInteractionComponent } from './component/slakpi/sla-interaction/sla-interaction.component';
import { KPIInteractionComponent } from './component/slakpi/kpi-interaction/kpi-interaction.component';
import { SLAKPIMappingComponent } from './component/slakpi/slakpi-mapping/slakpi-mapping.component';
import { KPIReleaseComponent } from './component/slakpi/kpi-release/kpi-release.component';
import { KPIInboxComponent } from './component/slakpi/kpi-inbox/kpi-inbox.component';
import { KPIAdminComponent } from './component/slakpi/kpi-admin/kpi-admin.component';
import { KPIViewComponent } from './component/slakpi/kpi-view/kpi-view.component';
import { KPITargetComponent } from './component/slakpi/kpi-target/kpi-target.component';
import { KPIBandComponent } from './component/slakpi/kpi-band/kpi-band.component';
import { SLAPerformanceComponent } from './component/slakpi/sla-performance/sla-performance.component';
import { SLAKPIPerformanceComponent } from './component/slakpi/slakpi-performance/slakpi-performance.component';
import {SLAKPIPerformanceHistoryComponent } from './component/slakpi/slakpi-performance-history/slakpi-performance-history.component';
import { SLAIssueListComponent } from './component/slakpi/slaissue-list/slaissue-list.component';
import { SLAKPIDatabaseComponent } from './component/slakpi/slakpi-database/slakpi-database.component';
import { KPIAllHistoryComponent } from './component/slakpi/kpi-allhistory/kpi-allhistory.component';
import { KPIInfoComponent } from './component/slakpi/kpi-info/kpi-info.component';

import { SLAPerformanceNewComponent } from './component/slakpi/dashboard/sla-performance/slaperformance.component';
import { SLAPerformanceViewComponent } from './component/slakpi/dashboard/sla-performance-view/sla-performance-view.component';
import { SLAKPIComponent } from './component/slakpi/dashboard/sla-kpi/slakpi.component';
import { SLAKPIViewComponent } from './component/slakpi/dashboard/slakpi-view/slakpi-view.component';

import { FileUploadModule } from '@iplab/ngx-file-upload';
import { NgHttpLoaderModule } from 'ng-http-loader';

import { NoWhitespaceDirective } from './helper/whitespace-validator/no-whitespace.directive';
import { AccessDeniedComponent } from './component/access-denied/access-denied.component'
import { BnNgIdleService } from 'bn-ng-idle';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { GoogleChartsModule } from 'angular-google-charts';

import { ToasterContainerComponent } from './toaster-container.component';
import { ToasterComponent } from './toaster.component';
import { ToasterService } from './toaster.service';
import { GaugeChartModule } from 'angular-gauge-chart'

//BenchMark
import {IncomingOutgoingDashboardComponent } from './component/benchmark/bench-mark-incoming-dashboard/bench-mark-incoming-dashboard.component';
import {BMOutgoingDashboardComponent } from './component/benchmark/bench-mark-outgoing-dashboard/bench-mark-outgoing-dashboard.component';
import { PracticeBMDashboardComponent } from './component/benchmark/practice-bm-progress/practice-bm-dashboard/practice-bm-dashboard.component';
import { PerformanceMasterComponent } from './component/admin/benchmarking/performance-master/performance-master.component';
import { BenchMarkKPIViewComponent } from './component/benchmark/bench-mark-kpi-view/bench-mark-kpi-view.component';
import { BenchMarkKPIComponent } from './component/benchmark/bench-mark-kpi/bench-mark-kpi.component';
import { BenchMarkInboxComponent } from './component/benchmark/bench-mark-inbox/bench-mark-inbox.component';
import { BenchMarkPositionComponent } from './component/benchmark/bench-mark-position/bench-mark-position.component';
import { BenchMarkIncomingComponent } from './component/benchmark/bench-mark-incoming/bench-mark-incoming.component';
import { BenchMarkIncomingTransactionComponent } from './component/benchmark/bench-mark-incoming-transaction/bench-mark-incoming-transaction.component';
import { BenchMarkOutgoingComponent } from './component/benchmark/bench-mark-outgoing/bench-mark-outgoing.component';
import { BenchMarkOutgoingStatusComponent } from './component/benchmark/bench-mark-outgoing-status/bench-mark-outgoing-status.component';
import { BenchMarkIncomingOutgoingComponent } from './component/benchmark/bench-mark-kpi-info/bench-mark-kpi-info.component';
import { BenchMarkDashboardComponent } from './component/benchmark/bench-mark-dashboard/bench-mark-dashboard.component';
import { BenchMarkHomeComponent } from './component/benchmark/bench-mark-home/bench-mark-home.component';
import { BenchmarkChartExportComponent } from './component/benchmark/bench-mark-chart-export/bench-mark-chart-export.component';

import { SurveyViewComponent } from './component/benchmark/survey-view/survey-view.component';
import { BenchMarkReleaseComponent } from './component/benchmark/bench-mark-release/bench-mark-release.component';
import { BenchmarkKPITargetComponent } from './component/benchmark/bench-mark-kpi-target/bench-mark-kpi-target.component';
import { BenchMarkDatabaseComponent } from './component/benchmark/bench-mark-database/bench-mark-database.component';
import { BenchMarkNavigationComponent } from './component/benchmark/bench-mark-navigation/bench-mark-navigation.component';
import { AnnualPerformanceBMComponent } from './component/annual/annual-performane-bm/annual-performane-bm.component';
import { AnnualPracticeBMComponent } from './component/annual/annual-practice-bm/annual-practice-bm.component';
import { AnnualOutingVisitComponent } from './component/annual/annual-outing-visit/annual-outing-visit.component';
import { AwarenessSessionComponent } from './component/annual/awareness-session/awareness-session.component';
import { PracticeBMProgressMasterComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-master/practice-bm-progress-master.component';
import { PracticeBMProgressTransactionListComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-transaction-list/practice-bm-progress-transaction-list.component';
import { PracticeBMProgressTransactionAddComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-transaction-add/practice-bm-progress-transaction-add.component';
import { SurveyOptionMasterComponent } from './component/survey-option-master/survey-option-master.component';
import { SurveyQuestionMasterComponent } from './component/survey-question-master/survey-question-master.component';
import { SurveyReportComponent } from './component/survey-report/survey-report.component';


import { PracticeBMProgressTransactionComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-transaction/practice-bm-progress-transaction.component';
import { PracticeBMProgressTransactionApprovedListComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-transaction-approved-list/practice-bm-progress-transaction-approved-list.component';
import { PracticeBMProgressApprovalListComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-approval-list/practice-bm-progress-approval-list.component';
import { PracticeBMProgressApprovalComponent } from './component/benchmark/practice-bm-progress/practice-bm-progress-approval/practice-bm-progress-approval.component';
import { OutgoingBMRequestMasterComponent } from './component/requestpending/outgoing-bm-request-master/outgoing-bm-request-master.component';
import { BMRequestMasterComponent } from './component/requestpending/bm-request-master/bm-request-master.component';
import { IncomingBMRequestMasterComponent } from './component/requestpending/incoming-bm-request-master/incoming-bm-request-master.component';
import { FileManagerComponent } from './component/benchmark/file-manager/file-manager.component';
import { RecentUpdatesComponent } from './component/recentupdates/recentupdates.component';
import { KPIPerformanceViewComponent } from './component/slakpi/kpi-performance-view/kpi-performance-view.component';
import { TranslatePageComponent } from './component/translate-page/translate-page.component';
import { ClearPageComponent } from './component/clear-page/clear-page.component';

import { ActionPlanComponent } from './component/slakpi/action-plan/action-plan.component';
import { SLAIssueActionComponent } from './component/slakpi/slaissue-action/slaissue-action.component';
import { ActionPlanDetailComponent } from './component/slakpi/action-plandetail/action-plandetail.component';
import { DelegatesHappinessRateMasterComponent } from './component/delegates-happiness-rate-master/delegates-happiness-rate-master.component';
import { KpiMappingComponent } from './component/slakpi/kpi-mapping/kpi-mapping.component';
import { KpiYearMappingComponent } from './component/benchmark/kpi-year-mapping/kpi-year-mapping.component';
import { KPIFollowUpComponent } from './component/slakpi/kpi-follow-up/kpi-follow-up.component';
import { KpiDelegationComponent } from './component/slakpi/kpi-delegation/kpi-delegation.component';

const appRoutes: Routes = [
  { path: 'dashboard', component: DashboardComponent }, 
  { path: 'dashboard-digital', component: DashboardDigitalComponent },
  { path: 'translate-page', component: TranslatePageComponent },
  { path: 'clear-page', component: ClearPageComponent },
  { path: 'notification', component: NotificationComponent },
  { path: 'sladashboard/:pagetype', component: SLADashboardComponent },
  { path: 'admindashboard', component: AdminboardComponent },  
  //{ path: 'admin', component: AdminComponent },
  { path: 'departments', component: DepartmentComponent },
  { path: 'divisions', component: DivisionComponent },
  { path: 'interactions', component: InteractionComponent },
  { path: 'tenant', component: TenantComponent },
  { path: 'usermaster', component: UserMasterComponent },
  { path: 'userprofile', component: UserProfileComponent },
  { path: 'usergroup', component: UserGroupComponent },
  { path: 'inbox/:pagetype', component: KPIInboxComponent },
  { path: 'kpiinbox', component: KPIInboxComponent },
  { path: 'kpiadmin/:pagetype', component: KPIAdminComponent },
  { path: 'kpiview/:id', component: KPIViewComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login-ping', component: LoginPingIDComponent },
  { path: 'login-external', component: LoginExternalComponent },
  { path: 'sla', component: SLAComponent },
  { path: 'slakpi', component: KPIComponent },
  { path: 'slainteraction', component: SLAInteractionComponent },
  { path: 'kpiinteraction', component: KPIInteractionComponent },
  { path: 'slakpi-mapping/:pagetype', component: SLAKPIMappingComponent },  
  { path: 'kpitarget', component: KPITargetComponent },
  { path: 'kpiband', component: KPIBandComponent },
  { path: 'kpirelease', component: KPIReleaseComponent },
  { path: 'slaperformance', component: SLAPerformanceComponent },
  
  { path: 'dashboard-slaperformance', component: SLAPerformanceNewComponent },
  { path: 'dashboard-slaperformance-view/:slauno', component: SLAPerformanceViewComponent },
  { path: 'dashboard-slakpi', component: SLAKPIComponent },
  { path: 'dashboard-slakpi-view/:kpiuno', component: SLAKPIViewComponent },

  { path: 'slakpiperformance', component: SLAKPIPerformanceComponent },
  { path: 'kpi-performance-view/:id', component: KPIPerformanceViewComponent },
  { path: 'slakpiperformancehistory', component: SLAKPIPerformanceHistoryComponent },  
  { path: 'slaissuelist', component: SLAIssueListComponent },
  { path: 'slakpidatabase', component: SLAKPIDatabaseComponent },  
  { path: 'access-denied', component: AccessDeniedComponent },

  { path: 'pingcallback', component: PingcallbackComponent },
  { path: 'pingredirect', component: PingredirectComponent },

  { path: 'benchmark-kpi-target', component: BenchmarkKPITargetComponent },
  { path: 'performancemaster', component: PerformanceMasterComponent },
  { path: 'benchmarkkpi', component: BenchMarkKPIComponent },
  { path: 'benchmarkrelease', component: BenchMarkReleaseComponent },
  { path: 'benchmarkdashboard', component: BenchMarkDashboardComponent },
  { path: 'benchmarknavigation', component: BenchMarkNavigationComponent },
  { path: 'benchmarkkpiinfo/:kpiuno', component: BenchMarkIncomingOutgoingComponent },
  { path: 'benchmarkinbox', component: BenchMarkInboxComponent },
  { path: 'benchmarkposition', component: BenchMarkPositionComponent },
  { path: 'benchmarkincoming', component: BenchMarkIncomingComponent },
  { path: 'benchmark-home', component: BenchMarkHomeComponent },
  { path: 'benchmark-incoming-transaction', component: BenchMarkIncomingTransactionComponent },
  { path: 'benchmark-outgoing', component: BenchMarkOutgoingComponent },
  { path: 'benchmark-outgoing-status', component: BenchMarkOutgoingStatusComponent },
  { path: 'benchmark-chart-export', component: BenchmarkChartExportComponent },
  { path: 'survey-view/:id', component: SurveyViewComponent },
  { path: 'benchmarkkpiview/:id', component: BenchMarkKPIViewComponent },
  { path: 'incomingoutgoingdashboard', component: IncomingOutgoingDashboardComponent },
  { path: 'outgoingdashboard', component: BMOutgoingDashboardComponent },
  { path: 'practiceBMdashboard', component: PracticeBMDashboardComponent },
  { path: 'benchmark-trackingsheet', component: BenchMarkDatabaseComponent },
  { path: 'annual-performane-bm', component: AnnualPerformanceBMComponent },
  { path: 'annual-practice-bm', component: AnnualPracticeBMComponent },
  { path: 'annual-outing-visit', component: AnnualOutingVisitComponent },
  { path: 'awareness-session', component: AwarenessSessionComponent },  
  { path: 'practice-bm-progress-master', component: PracticeBMProgressMasterComponent },
  { path: 'practice-bm-progress-transaction-list', component: PracticeBMProgressTransactionListComponent },
  { path: 'practice-bm-progress-transaction', component: PracticeBMProgressTransactionComponent },
  { path: 'practice-bm-progress-transaction-add', component: PracticeBMProgressTransactionAddComponent },
  { path: 'survey-option-master', component: SurveyOptionMasterComponent },
  { path: 'survey-question-master', component: SurveyQuestionMasterComponent },
  { path: 'survey-report/:id', component: SurveyReportComponent },
  { path: 'practice-bm-progress-transaction-approved-list', component: PracticeBMProgressTransactionApprovedListComponent },
  { path: 'practice-bm-progress-approval-list', component: PracticeBMProgressApprovalListComponent },
  { path: 'practice-bm-progress-approval', component: PracticeBMProgressApprovalComponent },
  { path: 'outgoing-bm-request-master', component: OutgoingBMRequestMasterComponent },
  { path: 'bm-request-master', component: BMRequestMasterComponent },
  { path: 'incoming-bm-request-master', component: IncomingBMRequestMasterComponent },
  { path: 'file-manager', component: FileManagerComponent },
  { path: 'recentupdates', component: RecentUpdatesComponent },
  //{ path: 'kpiuser', component: KPIUserComponent }, 
  { path: 'dashboard-actionplan', component: ActionPlanComponent },
  { path: 'dashboard-issueactionplan', component: SLAIssueActionComponent },
  { path: 'dashboard-actionplandetail', component: ActionPlanDetailComponent },
  { path: 'delegates-happiness-rate-master', component: DelegatesHappinessRateMasterComponent },
  { path: 'kpi-delegate', component: KpiDelegationComponent },
  //{ path: 'bm', loadChildren: './appbenchmark.module#AppBenchmarkModule' },
  { path: 'bm-kpi-mapping', component: KpiMappingComponent },
  { path: 'bmkpimapping', component: KpiYearMappingComponent },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [
    
    AppComponent,    
    //DragandDropComponent,
    PingcallbackComponent,
    PingredirectComponent,
    NotauthorizedComponent,
    DashboardComponent,
    DashboardDigitalComponent,
    TranslatePageComponent,
    ClearPageComponent,
    NotificationComponent,
    SLADashboardComponent,
    AdminboardComponent,
   AdminComponent,
    InboxComponent,
    LoginComponent,
    LoginPingIDComponent,
    LoginExternalComponent,
    DepartmentComponent,
    DivisionComponent,
    InteractionComponent,
    TenantComponent,
    UserGroupComponent,
    UserMasterComponent,
    UserProfileComponent,
    SLAComponent,
    KPIComponent,
    KPIAdminComponent,
    KPIViewComponent,
    SLAInteractionComponent,
    KPIInteractionComponent,
    SLAKPIMappingComponent,
    KPIReleaseComponent,
    KPITargetComponent,
    KPIBandComponent,
    KPIInboxComponent,
    SLAPerformanceComponent,
    SLAKPIPerformanceComponent,
    KPIPerformanceViewComponent,
    SLAKPIPerformanceHistoryComponent,
    SLAKPIDatabaseComponent,
    KPIAllHistoryComponent,
    KPIInfoComponent,
    SLAIssueListComponent,
    NoWhitespaceDirective,
    AccessDeniedComponent,    
    ToasterContainerComponent,
    ToasterComponent,

    SLAPerformanceNewComponent,
    SLAPerformanceViewComponent,
    SLAKPIComponent,
    SLAKPIViewComponent,
    //Benchmark
    BenchMarkDatabaseComponent,
    BenchmarkKPITargetComponent,
    PerformanceMasterComponent,
    AnnualPerformanceBMComponent,
    AnnualPracticeBMComponent,
    AnnualOutingVisitComponent,
    AwarenessSessionComponent,
    BenchMarkKPIComponent,
    BenchMarkHomeComponent,
    BenchMarkPositionComponent,
    BenchmarkChartExportComponent,
    BenchMarkIncomingComponent,
    BenchMarkIncomingTransactionComponent,
    BenchMarkOutgoingComponent,
    BenchMarkOutgoingStatusComponent,
    BenchMarkInboxComponent,
    BenchMarkIncomingOutgoingComponent,
    BenchMarkDashboardComponent,
    BenchMarkKPIViewComponent,
    BenchMarkReleaseComponent,
    BenchMarkNavigationComponent,
    SurveyViewComponent,
    PracticeBMProgressMasterComponent,
    PracticeBMProgressTransactionListComponent,
    PracticeBMProgressTransactionAddComponent,
    SurveyOptionMasterComponent,
    SurveyQuestionMasterComponent,
    PracticeBMProgressTransactionComponent,
    IncomingOutgoingDashboardComponent,
    PracticeBMDashboardComponent,
    BMOutgoingDashboardComponent,
    SurveyReportComponent,
    PracticeBMProgressTransactionApprovedListComponent,
    PracticeBMProgressApprovalListComponent,
    PracticeBMProgressApprovalComponent,
    OutgoingBMRequestMasterComponent,
    BMRequestMasterComponent,
    IncomingBMRequestMasterComponent,
    FileManagerComponent,
    RecentUpdatesComponent,
    //KPIUserComponent,
    ActionPlanComponent,
    SLAIssueActionComponent,
    ActionPlanDetailComponent,
    DelegatesHappinessRateMasterComponent,
    KpiMappingComponent,
    KpiYearMappingComponent,
    KPIFollowUpComponent,
    KpiDelegationComponent
    
  ],
  imports: [
    BrowserModule,
    FileUploadModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),

    ////MatButtonModule,
    ////MatRadioModule,
    ////MatCheckboxModule,
    ////MatSelectModule,
    ////MatTooltipModule,
    ////MatSliderModule,
    NgxSliderModule,
    ////MatMenuModule,
    MatStepperModule,
    ////MatTabsModule,
    //MatSidenavModule,
    TreeViewModule,
    ////UploaderModule,
    ////NumericTextBoxModule,
    TreeModule.forRoot(),
    ////GridModule,
    ////MultiSelectModule,
    ////DropDownListModule,
    CheckBoxModule,
    SwitchModule,
    ////ChartAllModule, AccumulationChartAllModule, RangeNavigatorAllModule,
    ////DatePickerModule,
    ////DialogModule,
    ////CircularGaugeModule,
    FormsModule,
    ReactiveFormsModule,
    LyResizingCroppingImageModule,
    LyIconModule,
    LyButtonModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    LyThemeModule.setTheme('minima-light'),    
    //AppRoutingModule,  
    //TreeModule.forRoot(),
    NgHttpLoaderModule.forRoot(),
    CommonModule,
    NgxSkeletonLoaderModule,
    GoogleChartsModule,
   ModalModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    NgxSelectModule,
    AngularSlickgridModule.forRoot(),
    AngularEditorModule,
    ContextMenuModule.forRoot(),
    //NgxEchartsModule.forRoot({ echarts: chartModule }),
    NgxEchartsModule,
    DragDropModule,
    GaugeChartModule,
    RecaptchaModule,
    AccordionModule.forRoot(),
    TabsModule.forRoot(),
    UiSwitchModule,
    RouterModule.forRoot(appRoutes, { useHash: true })],

  providers: [
    ////PageService,
    BnNgIdleService,
    NgRecaptcha3Service,
    ////SortService,
    ////ToolbarService,
    ////FilterService,
    ////EditService,
    ////GroupService,
    ////ExcelExportService,
    KPIAllHistoryComponent, 
    KPIInfoComponent, 
    { provide: LY_THEME, useClass: MinimaLight, multi: true }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
